import React from 'react';
import { Route, Routes } from 'react-router-dom';
import { ClaimContext, ClaimData } from '../../context/claim';
import {
	PremiumReportContext,
	PremiumReportData,
} from '../../context/premiumReport';
import Breadcrumbs from '../claims/Breadcrumbs';
import ClaimActions from '../claims/ClaimActions';
import ClaimOverview from '../claims/ClaimOverview';
import SubclaimActions from '../claims/SubclaimActions';
import { BodyContainer, LayoutContainer, TopContainer } from '../common';
import LargeCenterSpinner from '../LargeCenterSpinner';

interface Props {
	children?: JSX.Element | JSX.Element[];
	premiumReportData: PremiumReportData;
	claimData: ClaimData;
}

const ClaimLayout = (props: Props) => {
	const { claimData } = props;
	const [loading, setLoading] = React.useState<boolean>(false);
	claimData.setLoading = setLoading;

	const renderActions = () => {
		return (
			<Routes>
				<Route path={`subclaims/:subclaimId`} element={<SubclaimActions />} />
				<Route path={'details'} element={<ClaimActions />} />
				<Route path={'subclaims'} element={<ClaimActions />} />
			</Routes>
		);
	};

	return (
		<ClaimContext.Provider value={claimData}>
			{loading ? <LargeCenterSpinner /> : null}
			<TopContainer>
				<Breadcrumbs />
				{renderActions()}
			</TopContainer>
			<LayoutContainer>
				<BodyContainer>
					<ClaimOverview />
					{props.children}
				</BodyContainer>
			</LayoutContainer>
		</ClaimContext.Provider>
	);
};

function withContext<T>(Component: any) {
	return (props: Omit<T, 'policyData' | 'premiumReportData' | 'claimData'>) => (
		<ClaimContext.Consumer>
			{(claimData) => (
				<PremiumReportContext.Consumer>
					{(premiumReportData) => (
						<Component
							{...props}
							claimData={claimData}
							premiumReportData={premiumReportData}
						/>
					)}
				</PremiumReportContext.Consumer>
			)}
		</ClaimContext.Consumer>
	);
}

export default withContext<Props>(ClaimLayout);
